finderApp.service('accountService', ['$q', '$http', function($q, $http) {
    "use strict";

    var accountService = {
        getUserData: function() {
            return $q.when()
                .then(function() {
                    if (Account.isValidSession()) {
                        return Account.getUserData();
                    }
                });
        },
        getUpgrades: function() {
            return accountService.getUserData()
                .then(function(userContent) {
                    if (userContent && userContent.upgrades && userContent.upgrades.length) {
                        return userContent.upgrades;
                    }
                    return [];
                });
        },
        getRegistrations: function() {
            return accountService.getUserData()
                .then(function(userContent) {
                    if (userContent && userContent.registrations && userContent.registrations.length) {
                        return userContent.registrations;
                    }
                    return [];
                });
        },
        getUpgradeSkus: function() {
            return accountService.getUserData()
				.then(function(userContent) {
					if (userContent && userContent.upgradeOptions && userContent.upgradeOptions.length) {
						return userContent.upgradeOptions;
					}
					return [];
				});
        },
        setShownUpdates: function(productsList) {
            return Account.getUserData()
                .then(function(userContent) {
                    userContent.shown_upgrades = (userContent.shown_upgrades || [])
                        .concat(productsList.map(function(product) {
                            return product.sku;
                        }))
                        .filter(function(sku, index, array) {
                            return array.indexOf(sku) === index;
                        });


                    userContent = Account.storeUserData(userContent);



                    return $http({
                        method: 'POST',
                        url: finderConfig.upgradeOfferedUrl,
                        data: $.param({products: userContent.shown_upgrades}),
                        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
                    }).then((data) => {
                        window.emitter && window.emitter.emit('shown-upgrades-changed');
                        return data;
                    });
                });
        }
    };

    return accountService;
}]);
